import React, { useState } from "react";

import AnchorRightIcon from "assets/breakfast-event/svgs/anchor-right.svg";
import SmartcomplyTechcalalBgImage from "assets/desktop-research/images/hero-background.png";
import DesktopResearchImage from "assets/breakfast-event/png-jpg/desktop-research.png";
import HeroImage from "assets/desktop-research/images/hero-image.png";

import { useTranslation } from "react-i18next";
import AccessReportModal from "./AccessReportModal";

const HeroSection = () => {
  const { t } = useTranslation("event");
  const [open, setOpen] = useState(false);

  const handleRedirect = () => {
    window.open(
      "https://drive.google.com/file/d/1gJcShzSSU6L-Ohzty-Lcxp_PEborDImq/view?usp=sharing",
      "_blank",
    );
  };
  return (
    <div className="mt-[5rem] font-bebas">
      <div
        className="w-full lg:h-[730px] overflow-hidden  bg-cover bg-center relative flex justify-center items-start text-white"
        style={{ backgroundImage: `url(${SmartcomplyTechcalalBgImage})` }}
      >
        <div className="flex justify-between items-start flex-col lg:flex-row mt-[3rem] mb-[8rem] lg:mt-[7rem] lg:mb-0 w-[90%] xl:w-[92%]">
          <div className="lg:w-[60%]">
            <img
              src={DesktopResearchImage}
              alt="DesktopResearchImage"
              className="w-[250px] h-[24px] md:w-[315px] md:h-[33px]"
            />
            <div className="space-y-8 mt-5">
              <div className="space-y-3">
                <p className="text-3xl md:text-[36px] uppercase md:leading-[50px] xl:w-[80%] tracking-wide font-bebas">
                  {t("faq.ai_title")}
                </p>

                <h6 className="xl:w-[80%] text-xl font-euclidMedium">
                  {t("desktopResearch.subTitle")}
                </h6>
                <p className="md:w-[80%] text-base font-euclidRegular">
                  {t("desktopResearch.description")}
                </p>
              </div>
              <div onClick={handleRedirect}>
                <div
                  className="flex items-center"
                  onClick={() => setOpen(true)}
                >
                  <button className="bg-[#202D66] font-euclid text-white text-base xl:text-base font-euclidSemibold h-[48px] px-6 md:px-5 rounded-l-[16px] rounded-r-none">
                    {t("desktopResearch.cta1")}
                  </button>
                  <button className="bg-[#AFF7CD] text-white text-base font-euclidSemibold h-[48px] px-5 rounded-r-[16px] rounded-l-none flex items-center justify-center">
                    <img src={AnchorRightIcon} alt="AnchorRightIcon" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div>
            <img
              src={HeroImage}
              alt="HeroImage"
              className="w-[330px] md:w-[352px] h-[400px] md:h-[440px] mt-[2rem] md:mt-0"
            />
          </div>
        </div>
      </div>
      <AccessReportModal isOpen={open} onClose={() => setOpen(false)} />
    </div>
  );
};

export default HeroSection;
